import {
  HANDLE_PROJECT_NAME,
  HANDLE_PARAMETER_LIST,
  PROJECTS_PARAMETERS,
  INVESTIGATION_TABLE_DATA,
  FILTERD_REPORTS_DATA_LIST,
  PREVIEW_BATCH_RECORDS,
  PROJECT_NAME_API_STATUS,
  GET_VISUALIZATION_DETAILS,
  VISUALIZATION_SUBMIT_RESULT,
  VISUALIZATION_SUBMIT_QUERY,
  VISUALIZATION_DATA_HISTORY,
  GET_VISUALIZATION_PROJECTS,
  GET_FILES_FOR_PREVIEW_LIST,
  EXPORT_INVESTIGATION_DATA_API_STATUS,
  GET_TASKS_DATA,
  API_STATUS_MASTER,
  PRODUCT_TYPE_BATCH_NAME_USER_NAME,
  DASHBOARD_LOG_TILES_DATA,
  BATCH_NAMES,
  BATCH_TILES_DATA,
  BATCH_DOCUMENTS,
  BATCH_PARAMETERS,
  BATCH_LOGS,
  GET_PROJECTS_AND_BATCHES_WITH_STATUS_COUNTS,
  // GET_BATCH_STATUS_TILES,
  GET_BATCH_STATUS,
  GET_PROJECT_AND_BATCHES,
  GET_COUNTS_PER_DRUG_PRODUCTS,
  GET_DRUG_PRODUCTS,
  GET_BATCH_TILES_DATA,
  GET_BATCH_TILES_FILTERS_DATA,
  GET_BATCH_LOGS_FILTERS_DATA,
  GET_ALL_BATCH_TILES_API_STATUS,
  GET_ALL_PREVIOUS_REPORTS_LIST_API_STATUS,
  API_STATUS_GET_LOGS,
  GET_LOG_PDF_URL,
  INVESTIGATION_SEARCH_API_STATUS,
  DASHBOARD_TILES_API_STATUS_MASTER,
  // SUBMIT_OUT_PUT_FILE_UPLOAD,
  // REJECT_OUT_PUT_FILE_BATCH,
  GET_OUT_PUT_URL,
} from "./types";
import { initialState } from "./initialState";
import { API_STATUS } from "./types";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case HANDLE_PROJECT_NAME:
      return {
        ...state,
        projectName: action.payload,
        error: action.payload,
      };
    case API_STATUS:
      return {
        ...state,
        apiStatus: action.payload,
      };
    case API_STATUS_MASTER:
      return {
        ...state,
        apiStatus: action.payload,
      };
    case HANDLE_PARAMETER_LIST:
      return {
        ...state,
        parameterList: action.payload,
      };

    case PROJECTS_PARAMETERS:
      return {
        ...state,
        projectsParameters: action.payload,
      };

    case INVESTIGATION_TABLE_DATA:
      return {
        ...state,
        tableData: action?.payload,
      };
    case FILTERD_REPORTS_DATA_LIST:
      return {
        ...state,
        reportsDataList: action?.payload,
      };
    case PREVIEW_BATCH_RECORDS:
      return {
        ...state,
        previewBatchRecords: action?.payload,
      };
    case PROJECT_NAME_API_STATUS:
      return {
        ...state,
        projectNameApiStatus: action.payload,
      };
    case GET_VISUALIZATION_DETAILS:
      return {
        ...state,
        visualizationDetails: action?.payload,
      };
    case VISUALIZATION_SUBMIT_RESULT: {
      return {
        ...state,
        visualizationResultStatus: action?.payload,
      };
    }
    case VISUALIZATION_SUBMIT_QUERY: {
      return {
        ...state,
        visualizationQueryStatus: action?.payload,
      };
    }
    case VISUALIZATION_DATA_HISTORY: {
      return { ...state, visualizationDataHistory: action?.payload };
    }
    case GET_VISUALIZATION_PROJECTS: {
      return { ...state, visualizationProjectsList: action?.payload };
    }
    case GET_FILES_FOR_PREVIEW_LIST:
      return {
        ...state,
        filesForPreviewData: action.payload,
      };
    case EXPORT_INVESTIGATION_DATA_API_STATUS: {
      return {
        ...state,
        exportInvestigationDataStatus: action.payload,
      };
    }
    case GET_TASKS_DATA:
      return {
        ...state,
        tasksData: action.payload,
      };

    case PRODUCT_TYPE_BATCH_NAME_USER_NAME:
      return {
        ...state,
        productTypesBatchAndUserNames: action.payload,
      };

    case DASHBOARD_LOG_TILES_DATA:
      return {
        ...state,
        dashboardLogsTilesData: action.payload,
      };
    case BATCH_NAMES:
      return {
        ...state,
        batchNames: action.payload,
      };

    case BATCH_TILES_DATA:
      return {
        ...state,
        batchTilesDataOfProject: action.payload,
      };
    case BATCH_DOCUMENTS:
      return {
        ...state,
        batchDocuments: action.payload,
      };
    case BATCH_PARAMETERS:
      return {
        ...state,
        batchParameters: action.payload,
      };

    case BATCH_LOGS:
      return {
        ...state,
        batchLogs: action.payload,
      };

    case GET_PROJECTS_AND_BATCHES_WITH_STATUS_COUNTS:
      return {
        ...state,
        projectsAndBatchesWithStatusCounts: action.payload,
      };

    case GET_DRUG_PRODUCTS:
      return {
        ...state,
        drugProducts: action.payload,
      };

    case GET_COUNTS_PER_DRUG_PRODUCTS:
      return {
        ...state,
        countsPerDrugProducts: action.payload,
      };

    case GET_PROJECT_AND_BATCHES:
      return {
        ...state,
        projectAndBatches: action.payload,
      };

    case GET_BATCH_STATUS:
      return {
        ...state,
        batchStatus: action.payload,
      };

    case GET_BATCH_TILES_DATA: {
      return {
        ...state,
        batchTilesData: action.payload,
      };
    }
    case GET_BATCH_TILES_FILTERS_DATA: {
      return {
        ...state,
        batchTilesFiltesData: action.payload,
      };
    }

    case GET_BATCH_LOGS_FILTERS_DATA: {
      return {
        ...state,
        batchFiltersData: action.payload,
      };
    }
    case GET_ALL_BATCH_TILES_API_STATUS:
      return {
        ...state,
        apiStatusGetAllBatchTiles: action.payload,
      };
    case GET_ALL_PREVIOUS_REPORTS_LIST_API_STATUS:
      return {
        ...state,
        repostListAPiStatus: action.payload,
      };

    case API_STATUS_GET_LOGS:
      return {
        ...state,
        logsApiStatus: action.payload,
      };

    case GET_LOG_PDF_URL: {
      return {
        ...state,
        urlData: action.payload,
      };
    }

    case INVESTIGATION_SEARCH_API_STATUS:
      return {
        ...state,
        investigationSearchApiStatus: action.payload,
      };
    case DASHBOARD_TILES_API_STATUS_MASTER:
      return {
        ...state,
        dashboardLogsTilesApiStatus: action?.payload,
      };

    case GET_OUT_PUT_URL:
      return {
        ...state,
        outPutUrl: action.payload,
      };

    default: {
      return {
        ...state,
      };
    }
  }
};
export default reducer;
